"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _commons = require("@focaltec-suite/commons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ExtendedFieldInput(_ref) {
  var value = _ref.value,
    extendedField = _ref.extendedField,
    disabled = _ref.disabled,
    _ref$regexMessage = _ref.regexMessage,
    regexMessage = _ref$regexMessage === void 0 ? 'validations.regex' : _ref$regexMessage,
    s3Client = _ref.s3Client,
    catalogs = _ref.catalogs,
    register = _ref.register;
  var fieldType = extendedField.type,
    _extendedField$regex = extendedField.regex,
    regex = _extendedField$regex === void 0 ? '' : _extendedField$regex,
    required = extendedField.required,
    reference = extendedField.reference;
  var validators = (0, _react.useMemo)(function () {
    if (fieldType === 'INTEGER') {
      return [new _commons.IntegerValidator()];
    }
    if (fieldType === 'REGEX') {
      return [new _commons.RegexValidator(new RegExp(regex), regexMessage)];
    }
    return [];
  }, [fieldType, regex, regexMessage]);
  var options = (0, _react.useMemo)(function () {
    var _a, _b, _c, _d;
    if (fieldType === 'CATALOG') {
      return (_d = (_c = (_b = (_a = catalogs === null || catalogs === void 0 ? void 0 : catalogs.find(function (catalog) {
        return catalog.id === reference;
      })) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.filter(function (el) {
        return !!el.active;
      })) === null || _c === void 0 ? void 0 : _c.map(function (el) {
        return {
          value: el.external_id,
          label: el.label
        };
      })) !== null && _d !== void 0 ? _d : [];
    }
    return [];
  }, [fieldType, reference, catalogs]);
  var initialValueFile = (0, _react.useMemo)(function () {
    if (fieldType === 'FILE' && value !== undefined) {
      var str = value;
      if (disabled) {
        var indexOfSlash = str.lastIndexOf('/');
        if (indexOfSlash >= 0) {
          return str.substring(indexOfSlash + 1);
        }
      }
      return str;
    }
  }, [fieldType, value, disabled]);
  if (fieldType === 'FILE') {
    return /*#__PURE__*/_react["default"].createElement(_commons.AnyUploader, {
      name: extendedField.id,
      label: extendedField.name,
      s3Client: s3Client,
      initialValue: initialValueFile,
      acceptExtension: extendedField.extensions,
      required: required,
      path: "tenants/".concat(extendedField.tenant_id, "/extended-fields/").concat(extendedField.id),
      disabled: disabled,
      register: register
    });
  }
  if (fieldType === 'CATALOG') {
    return /*#__PURE__*/_react["default"].createElement(_commons.AnyAutocomplete, {
      name: extendedField.id,
      label: extendedField.name,
      initialValue: value ? "".concat(value) : undefined,
      options: options,
      required: required,
      disabled: disabled,
      register: register
    });
  }
  if (fieldType === 'DATE' || fieldType === 'DATETIME') {
    return /*#__PURE__*/_react["default"].createElement(_commons.AnyDatePickerInput, {
      mode: fieldType === 'DATE' ? 'date' : 'datetime',
      name: extendedField.id,
      label: extendedField.name,
      initialValue: value ? fieldType === 'DATE' ? (0, _commons.parseDate)("".concat(value)) : (0, _commons.parseDateTime)("".concat(value)) : undefined,
      required: required,
      disabled: disabled,
      register: register
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
    type: fieldType === 'TEXT' || fieldType === 'REGEX' ? 'text' : 'number',
    name: extendedField.id,
    label: extendedField.name,
    initialValue: value,
    required: extendedField.required,
    disabled: disabled,
    maxLength: extendedField.length,
    validators: validators,
    register: register
  });
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ExtendedFieldInput);